export const validationMessages = {
    email: "podaj poprawny adres e-mail",
    number: "wartość musi być liczbą",
    required: "to pole jest wymagane",
    phone: "nieprawidłowy numer telefonu",
    maxLength: "maksymalna długość to 500 znaków"
};
export const validationMessages = {
    email: "podaj poprawny adres e-mail",
    number: "wartość musi być liczbą",
    required: "to pole jest wymagane",
    phone: "nieprawidłowy numer telefonu",
    maxLength: "maksymalna długość to 500 znaków"
};
